/**
 * @file Route: contacts
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { Header } from "components/Header/Contacts";
import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import "components/Book";
import { replaceFragment } from "@olmokit/core/fragments";
import { FormPrivate } from "components/Form/Contacts/Private";
import { FormProfessional } from "components/Form/Contacts/Professional";
import { FormProfessional2 } from "components/Form/Contacts/Professional2";
import "./index.scss";

console.log("Route contacts/index.js mounted.");

Header();

// User type tabs
const tabs = $all(".Tabs:box");
const contents = $all(".Content:");
forEach(tabs, (t) => {
    const type = t.getAttribute('data-type');
    on(t, 'click', (e) => {
        forEach(tabs, (t) => {
            removeClass(t, 'is-active');
        });
        addClass(t, 'is-active');
        forEach(contents, (c) => {
            c.style.display = 'none';
        })
        $('#'+type).style.display = 'block';
        // window.location.href = '#'+type;
    });
});

// Form navigation
const steps01 = $(".Contacts:navStep01");
const form1 = $('[data-fragment-id="professionalForm"]');
const form2 = $('[data-fragment-id="professional2Form"]');

on(steps01, 'click', (e) => {
    $('#step').innerHTML = '01';
    addClass(steps01, 'is-active');
    form1.style.display = 'block';
    form2.style.display = 'none';
});

replaceFragment("privateForm", "components.FormContactsPrivate").then(() => FormPrivate());
replaceFragment("professionalForm", "components.FormContactsProfessional").then(() => FormProfessional());
replaceFragment("professional2Form", "components.FormContactsProfessional2").then(() => FormProfessional2());

